var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-pagination',{attrs:{"current-page":_vm.pagination.page,"page-size":_vm.pagination.pageSize,"layout":"prev, pager, next","background":"","small":"","total":_vm.pagination.total},on:{"size-change":_setup.sizeChange,"current-change":_setup.currentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }